<div @fadeIn *ngIf="!isShowSkeleton">
    <div fxLayout="row wrap" fxLayoutAlign="end start" class="m-20">
        <button mat-raised-button color="primary" (click)="openUploadMediaPopup()">
            <mat-icon class="m-r-5">cloud_upload</mat-icon>Upload Documents</button>
    </div>
    <div fxLayout="row wrap">
        <mat-card fxFlex="30" class="thumbnail-container" *ngFor="let item of documents" (click)="getMedia(item)">
            <div fxLayoutAlign="center center" [ngClass]="{'divider': item.type !== 'image'}">
                <img class="image" *ngIf="item.type === 'image' && item.src" [src]="transform(item.src)">
                <img class="doc-image" *ngIf="item.type !== 'image'" [src]="item.src">
            </div>
            <div class="p-15">
                <div fxLayoutAlign="start center">
                    <mat-icon class="m-r-5">calendar_today</mat-icon>
                    <span>{{item.occurrenceDateTime | date :'MM-DD-YYYY hh:mm A'}}</span>
                </div>
            </div>
        </mat-card>
    </div>
</div>
<div fxLayout="row wrap" @fadeIn *ngIf="isShowSkeleton">
    <mat-card fxFlex="30" class="thumbnail-container skeleton" *ngFor="let item of documents">
        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '10', height: '350px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" [theme]="{height: '50px', top: '-10px', 'margin-bottom': '-15px'}">
        </ngx-skeleton-loader>
    </mat-card>
</div>